

















import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "orders-listing": () =>
      import("@/components/app/global/orders/ordersListing.vue")
  }
})
export default class ClientOrders extends Vue {}
